/**
 * Text Block Component
 * Displays lists of text items
 */

import { Button } from "@/components/ui/button";
import { TextBlock as TextBlockType } from "@/types/interview-feedback.types";
import { Lightbulb } from "lucide-react";

interface TextBlockProps {
  block: TextBlockType;
}

export const TextBlock = ({ block }: TextBlockProps) => {
  const { title, helper, items } = block;

  // Determine if "Create personalized lesson" button should show
  const showCreateLessonButton = title
    .toLowerCase()
    .includes("suggested sentences");

  return (
    <div className="space-y-4">
      {/* Title */}
      {title && <h3 className="text-xl font-bold text-foreground">{title}</h3>}

      {/* Helper */}
      {helper && <p className="text-sm text-muted-foreground">{helper}</p>}

      {/* Content */}
      <div className="space-y-3">
        {items.map((item, index) => {
          // Handle both string and object formats
          const text = typeof item === "string" ? item : item.text;

          return (
            <p
              key={index}
              className="text-sm text-foreground leading-relaxed p-3 rounded-lg bg-muted/20 backdrop-blur-sm hover:bg-muted/30 transition-colors"
            >
              {text}
            </p>
          );
        })}

        {/* Create Personalized Lesson Button */}
        {showCreateLessonButton && (
          <div className="pt-4 border-t border-border/50">
            <Button
              className="w-full bg-gradient-to-r from-primary to-accent hover:opacity-90 transition-opacity"
              disabled
            >
              <Lightbulb className="w-4 h-4 mr-2" />
              Create Personalized Lesson
              <span className="ml-2 text-xs opacity-75">(Coming Soon)</span>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

